import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import { drills } from 'redux/modules'
import PropTypes from 'prop-types'
import Loader from './Loader'

const DrillsCategoriesLoader = ({
  children,
  fetchDrillsCategories,
  activeLanguage: { code: locale },
  clubUuid,
  ...restProps
}) => (
  <Loader
    fetchMethod={() => fetchDrillsCategories({ locale, club_id: clubUuid })}
    triggers={[locale]}
    {...restProps}
  >
    {children}
  </Loader>
)

DrillsCategoriesLoader.propTypes = {
  children: PropTypes.node.isRequired,
  fetchDrillsCategories: PropTypes.func.isRequired,
  activeLanguage: PropTypes.shape().isRequired,
  clubUuid: PropTypes.string.isRequired,
}

export default compose(
  connect(
    ({ clubs }) => ({
      clubUuid: clubs.current.uuid,
    }),
    { fetchDrillsCategories: drills.fetchDrillsCategories }
  ),
  withLocalize
)(DrillsCategoriesLoader)
